export default function(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/number.js
// module id = 136
// module chunks = 0 1